import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const setupPartnersAnimation = (section, partnerCards) => {
  gsap.set(partnerCards, {
    opacity: 0,
    y: 10,
    scale: 0.95,
    filter: "blur(4px)"
  });

  const partnersTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 75%",
      end: "top 35%",
      toggleActions: "play none none reverse"
    }
  });

  partnersTimeline.to(partnerCards, {
    opacity: 1,
    y: 0,
    scale: 1,
    filter: "blur(0px)",
    duration: 0.8,
    stagger: 0.1,
    ease: "power3.out"
  });

  const isMobile = window.innerWidth <= 600;
  const wobbleAmount = 1.5;
  
  const floatingAnimations = partnerCards.map((card, index) => {
    return gsap.to(card, {
      y: index % 2 === 0 ? -wobbleAmount : wobbleAmount,
      duration: 2.5 + index * 0.15,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
      delay: index * 0.12
    });
  });

  ScrollTrigger.create({
    trigger: section,
    start: "top bottom",
    end: "bottom top",
    scrub: 1,
    onUpdate: self => {
      const progress = self.progress;

      gsap.set(".partners-row", {
        x: gsap.utils.interpolate(
          -5,
          5,
          progress
        )
      });
    }
  });


  partnerCards.forEach((card, index) => {
    if (!card) return;

    const handleEnter = () => {
      if (floatingAnimations[index]) {
        floatingAnimations[index].pause();
      }
      gsap.to(card, {
        yPercent: -15,
        scale: 1.04,
        duration: 0.35,
        ease: "power2.out",
        overwrite: "auto"
      });
    };

    const handleLeave = () => {
      gsap.to(card, {
        scale: 1,
        yPercent: 0,
        duration: 0.35,
        ease: "power2.out",
        overwrite: "auto",
        onComplete: () => {
          if (floatingAnimations[index]) {
            floatingAnimations[index].resume();
          }
        }
      });
    };

    card.addEventListener("mouseenter", handleEnter);
    card.addEventListener("mouseleave", handleLeave);

    card._handleEnter = handleEnter;
    card._handleLeave = handleLeave;
  });

  return () => {
    floatingAnimations.forEach(animation => {
      animation.kill();
    });

    partnerCards.forEach(card => {
      if (!card) return;

      card.removeEventListener(
        "mouseenter",
        card._handleEnter
      );

      card.removeEventListener(
        "mouseleave",
        card._handleLeave
      );
    });
  };
};

export const setupBecomePartnerAnimation = (cta) => {
  gsap.to(cta, {
    backgroundPosition: "100% 50%",
    duration: 8,
    repeat: -1,
    ease: "none"
  });

  gsap.to(".partners-glow-one", {
    x: 70,
    y: -25,
    duration: 5,
    repeat: -1,
    yoyo: true,
    ease: "sine.inOut"
  });

  gsap.to(".partners-glow-two", {
    x: -60,
    y: 35,
    duration: 6,
    repeat: -1,
    yoyo: true,
    ease: "sine.inOut"
  });
};
